<template>
  <div
    class="hydras-image-layer"
    :style="customStyles"
  >
    <img loading="lazy"
      v-for="(image, index) in imageSources"
      :key="index"
      :src="image.src"
      :class="{ active: image.key === activeImageIndex }"
      :alt="image.alt"
      :style="customStyles"
      class="hydras-image-layer__image"
    >
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  imageSources: { src: string; alt: string; key: string }[];
  activeImageIndex: string;
  imgWidth: string;
  imgHeight: string;
}>()

const customStyles = computed(() => {
  return 'width: ' + props.imgWidth + '; height: ' + props.imgHeight + ';'
})
</script>

<style lang="scss">
.hydras-image-layer {
  position: relative;

  &__image {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity .2s ease-in-out;

    &.active {
      opacity: 1;
    }
  }
}
</style>
